import styled from 'styled-components'

export const Section = styled.section`
	margin: 56px 0 0 0;

	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
		margin: 24px 0 0 0;
	}
`

export const SectionTitle = styled.h2`
	margin: 0 0 32px 0;
	font-size: 36px;
	font-weight: 600;

	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
		margin: 0 0 12px 0;
		font-size: 20px;
	}
`